import api from './api';

interface User {
  adminId: string;
  email: string;
  fullName: string;
  isActive: boolean;
}

class AuthService {
  async login(email: string, password: string): Promise<{ user: User; token: string }> {
    try {
      const response = await api.login(email, password);

      if (response.access_token) {
        // Store token
        localStorage.setItem('adminToken', response.access_token);

        // Store admin info
        const user: User = {
          adminId: response.admin.adminId,
          email: response.admin.email,
          fullName: response.admin.fullName,
          isActive: response.admin.isActive,
        };
        localStorage.setItem('adminUser', JSON.stringify(user));

        return { user, token: response.access_token };
      }
      throw new Error('Invalid response from server');
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Login failed');
    }
  }

  logout() {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    window.location.href = '/login';
  }

  getCurrentUser(): User | null {
    const userStr = localStorage.getItem('adminUser');
    if (!userStr) return null;

    try {
      return JSON.parse(userStr);
    } catch {
      return null;
    }
  }

  getToken(): string | null {
    return localStorage.getItem('adminToken');
  }

  isAuthenticated(): boolean {
    const token = this.getToken();
    const user = this.getCurrentUser();
    return !!(token && user && user.isActive);
  }
}

const authService = new AuthService();
export default authService;
